// The four legal documents that make up a terms version. They are published to
// the CDN under assets/assets/terms/{version}/{file} (see the repo's
// assets/assets/terms folder).
export const TERMS_DOCUMENTS = [
    { key: "tos", label: "Terms of service", file: "tos.md" },
    { key: "apt", label: "Additional product terms", file: "apt.md" },
    { key: "pp", label: "Privacy policy", file: "pp.md" },
    { key: "dpa", label: "Data processing agreement", file: "dpa.md" },
] as const;

export type TermsDocumentKey = (typeof TERMS_DOCUMENTS)[number]["key"];

export function termsDocumentUrl(version: string, file: string): string {
    return `https://assets.${
        import.meta.env.VITE_DOMAIN
    }/assets/terms/${version}/${file}`;
}
